import { createContext, MutableRefObject, useRef, useState } from "react";
import { appLayoutContentId } from "@amzn/meridian/app-layout";

export const PageContext = createContext(null);

export const PageContextProvider = ({ children }) => {
    const appLayoutContainerRef = useRef(document.getElementById(appLayoutContentId));
    const [isEditing, setIsEditing] = useState(false);
    const refMap = new Map<string, MutableRefObject<any>>();

    return (
        <PageContext.Provider value={{ appLayoutContainerRef, refMap, setIsEditing, isEditing }}>
            {children}
        </PageContext.Provider>
    );
};
